import type { SortDescriptor } from '@skupreme/shared/ui';
import { CommonConstant } from '@utility/constants/common';
import type { ISortObject, ITableColumn } from '../legacy-bridge';

/* Semantic UI sized columns against a 16-unit grid; the widths are kept. */
export function columnWidthStyle(width: ITableColumn['width']) {
  if (typeof width !== 'number') {
    return undefined;
  }

  return { width: `${((width / 16) * 100).toFixed(4)}%` };
}

/** The screen's `{ time_acknowledged: 'asc' }` as React Aria's descriptor. */
export function toSortDescriptor(
  columns: ITableColumn[],
  sort: ISortObject | undefined,
): SortDescriptor | undefined {
  const sorted = columns.find(
    column => column.sortKey && !column.hideSort && sort?.[column.sortKey],
  );

  if (!sorted?.sortKey) {
    return undefined;
  }

  return {
    column: sorted.key,
    direction:
      sort?.[sorted.sortKey] === CommonConstant.sortDirection.ascending
        ? 'ascending'
        : 'descending',
  };
}

export type SortRequest = { sort: ISortObject; key: string };

/** The reverse; null when the sorted column names no API field. */
export function fromSortDescriptor(
  columns: ITableColumn[],
  descriptor: SortDescriptor,
): SortRequest | null {
  const column = columns.find(item => item.key === descriptor.column);

  if (!column?.sortKey) {
    return null;
  }

  const direction =
    descriptor.direction === 'ascending'
      ? CommonConstant.sortDirection.ascending
      : CommonConstant.sortDirection.descending;

  return { sort: { [column.sortKey]: direction }, key: column.sortKey };
}
